<template>
  <div class="yingxiangzhizuoxue">
    <!-- 影像制作学 -->
    <div class="main">
      <div class="title">
        韩国东国大学
        <span>招生简章</span>
      </div>
      <p class="title11">为了培养文化产业顶尖创新人才，加强中韩艺术文化方面友好交流，东国大学在韩国教育部的审批与支持下，特开设中韩双语授课的影像制作学硕士项目。</p>
      <div class="xuezhi">
        <!-- <div class="top">学制信息</div> -->
        <div class="cell">
          <div class="biaoti">
            <div class="xuhao">招生对象</div>
            <!-- <div class="title"></div> -->
          </div>
          <div class="content">
            优秀大四在读生、优秀本科毕业生、硕士在读生/毕业生
          </div>
        </div>
        <!-- <div class="cell twoCell">
          <div class="biaoti">
            <div class="xuhao">招生对象</div>
            <div class="title"></div>
          </div>
          <div class="content">中文授课(部分课程配备中文翻译)</div>
        </div> -->
        <div class="cell threeCell">
          <div class="biaoti">
            <div class="xuhao">授课方式</div>
            <div class="title"></div>
          </div>
          <div class="content">中文授课(部分课程配备中文翻译)</div>
        </div>
        <div class="cell threeCell">
          <div class="biaoti">
            <div class="xuhao">授课学制</div>
            <div class="title"></div>
          </div>
          <div class="content">1.5年全日制(由3个常规学期及暑假学期构成)</div>
        </div>
        <div class="cell threeCell">
          <div class="biaoti">
            <div class="xuhao">所属学院</div>
            <div class="title"></div>
          </div>
          <div class="content">影像研究生院(首尔校区)</div>
        </div>
        <div class="cell threeCell">
          <div class="biaoti">
            <div class="xuhao">硕士专业</div>
            <div class="title"></div>
          </div>
          <div class="content">
           影像制作学硕士(文化资讯与创作)
          </div>
        </div>
      </div>
      <!-- <div class="biye">
        <div class="top">毕业要求</div>
        <div class="cell">
          <div class="icon">
            <img src="../../assets/images/dongguo/icon1.png" alt="" />
          </div>
          <span>修满36个学分，即通过12门学位课程，且平均绩点3.0以上；</span>
        </div>
        <div class="cell twoCell">
          <div class="icon">
            <img src="../../assets/images/dongguo/icon2.png" alt="" />
          </div>
          <span>通过综合专业考试(中文试卷)；</span>
        </div>
        <div class="cell threeCell">
          <div class="icon">
            <img src="../../assets/images/dongguo/icon3.png" alt="" />
          </div>
          <span>无硬性毕业论文要求；</span>
        </div>
        <div class="cell fourCell">
          <div class="icon">
            <img src="../../assets/images/dongguo/icon4.png" alt="" />
          </div>
          <span>无硬性韩语TOPIK等级和韩语考试要求。</span>
        </div>
      </div> -->
      <a href="/yingxiang.html" target="_blank" class="button">查看更多</a>
      <div class="yuanxi">
        <div class="title">
          韩国东国大学
          <span>院系介绍</span>
        </div>
        <div class="introduce">
          <div class="oneline">
            <div class="left">
              <div class="biaozhi"></div>
            </div>
            <span class="right">韩国戏剧表演和影视艺术研究的知名学府</span>
          </div>
          <div class="oneline diff twoline">
            <div class="left">
              <div class="biaozhi"></div>
            </div>
            <span class="right"
              >亚洲最早一批拿到招收 MFA （艺术硕士学位）资格的研究生院
            </span>
          </div>
          <div class="oneline diff">
            <div class="left">
              <div class="biaozhi"></div>
            </div>
            <span class="right">在影视与戏剧领域提供韩国先进“源泉技术”。</span>
          </div>
          <div class="oneline diff">
            <div class="left">
              <div class="biaozhi"></div>
            </div>
            <span class="right">以忠武路影像中心为中心构建“忠武路集聚区”</span>
          </div>
        </div>
      </div>
      <div class="jiaoyu">
        <span
          >东国大学影像研究生院历史悠久，学风严谨，其规模是目前韩国高校中设置学科门类较齐全，体系更完善，设施更先进的影视传媒艺术研究学府。</span
        >
        
        <p>影像大学院作为东国大学的王牌院系，一直是许多希望进入传媒领域、影视领域的同学们的深造首选。</p>
      </div>
      <a href="/schoolintroduction.html" target="_blank" class="button"
        >查看更多</a
      >
      <div class="zhenrong">
        <div class="title">
          韩国东国大学
          <span>教学阵容</span>
        </div>
      </div>
      <ul class="person">
        <li v-for="(item, index) in personList" :key="index">
          <img :src="item.url" alt="" />
          <div class="shenfen">
          </div>
        </li>
      </ul>
      <a href="/jiaoxue.html" target="_blank" class="button">查看更多</a>
      <div class="baoming">韩国东国大学申请报名</div>
      <!-- 表单 -->
      <div class="biaodanbox">
        <el-form :model="formLabelAlign" label-width="0px">
          <el-form-item>
            <p><span class="icon">*</span>您的姓名</p>
            <el-input
              v-model.trim="formLabelAlign.name"
              placeholder="请输入姓名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <p><span class="icon">*</span>联系方式</p>
            <el-input
              v-model="formLabelAlign.phone"
              placeholder="请输入手机号码"
            ></el-input>
          </el-form-item>
          <el-form-item class="margbottom0">
            <p><span class="icon">*</span>当前学历</p>
            <el-select
              v-model="formLabelAlign.xueli"
              placeholder="请输入当前学历"
              :popper-append-to-body="false"
            >
              <el-option
                v-for="item in formxueliList"
                :key="item.S99_CodeId"
                :label="item.S99_Name"
                :value="item.S99_CodeId"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="project">
            <p>意向专业</p>
            <el-input
              v-model="formLabelAlign.zhuanye"
              placeholder="请输入意向专业"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="button" @click="sbmitForm">提 交</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Notify } from "vant";
export default {
  metaInfo() {
    return {
      title: "影像制作学-韩国东国大学中文官网",
      meta: [
        {
          name: "keywords",
          content: "影像制作学招生简章,影像制作学院系介绍,影像制作学教学阵容",
        },
        {
          name: "description",
          content:
            "韩国东国大学中文官网为留学生提供韩国东国大学招生简章、影像制作学硕士招生简章以及硕士项目招生简章，韩国东国大学中文官网全程为您的韩国留学生涯保驾护航。",
        },
      ],
    };
  },
  name: "yingxiangzhizuoxue",
  components: {},
  props: {},
  data() {
    return {
      personList: [
        {
          url: require("../../assets/images/dongguo/组 2@2x.png"),
          // name: "车胜宰（차승재）",
        },
        {
          url: require("../../assets/images/dongguo/组 3@2x.png"),
          // name: "姜万石（강만석）",
        },
        {
          url: require("../../assets/images/dongguo/组 4@2x.png"),
          // name: "朴彌缘",
        },
      ],
      formxueliList: [],
      formLabelAlign: {
        name: "", //您的姓名
        phone: "", //联系方式
        xueli: "", //目前学历
        zhuanye: "", //意向专业
      },
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    //获取当前学历
    this.getXueliListInfo();
  },
  activated() {
    this.$emit("handleTKD", "影像制作学");
  },
  methods: {
    //form表单提交
    sbmitForm() {
      let _form = this.formLabelAlign;
      if (!_form.name) {
        Notify({ type: "warning", message: "请输入姓名！" });
        return false;
      }
      if (!this.formLabelAlign.phone) {
        Notify({ type: "warning", message: "请输入手机号码" });
        return true;
      } else {
        if (!Number(this.formLabelAlign.phone)) {
          Notify({ type: "warning", message: "手机号码只能为数字类型！" });
          this.formLabelAlign.phone = "";
          return false;
        }
      }
      if (!_form.xueli) {
        Notify({ type: "warning", message: "请输选择当前学历！" });
        return false;
      }
      this.$axios
        .post("/trip/InfoSources/WebRegister", {
          C01_Name: _form.name, //姓名
          C01_Tel: _form.phone, //联系方式
          EducationCode: _form.xueli, //当前学历
          C01_Major: _form.zhuanye, //意向专业
          C01_Origin: 239, //来源于那个官网
        })
        .then((res) => {
          if (res.data.Code == 200) {
            Notify({ type: "success", message: "提交成功！" });
            this.formLabelAlign.name = "";
            this.formLabelAlign.phone = "";
            this.formLabelAlign.xueli = "";
            this.formLabelAlign.zhuanye = "";
          } else {
            Notify({ type: "danger", message: res.data.Message });
          }
        });
    },
    //获取学历
    getXueliListInfo() {
      this.$axios
        .post("/trip/TokenPass/GetClueCode", {
          S99_GroupCode: "035",
        })
        .then((res) => {
          if (res.data.Code == 200) {
            this.formxueliList = res.data.Data;
          } else {
            Toast(res.data.Message);
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.yingxiangzhizuoxue {
  padding-top: 134px;
  margin-left: 40px;
  margin-right: 40px;
  .main {
    width: 100%;
    padding-top: 60px;
    .title {
      display: flex;
      margin: 0 auto;
      width: 434px;
      height: 39px;
      font-size: 40px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #333333;
      line-height: 39px;
      span {
        color: #f7901e;
      }
    }
    .title11 {
      margin-top: 48px;
      width: 668px;
      height: 107px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 41px;
      margin-bottom: 59px;
      }
    .xuezhi {
      // height: 760px;
      background: #ffffff;
      // border: 1px solid #dcdcdc;
      border-radius: 3px;
      margin-top: 39px;
      // padding-bottom: 40px;
      // .top {
      //   width: 100%;
      //   height: 67px;
      //   background: url("../../assets/images/dongguo/xuezhi.png") no-repeat;
      //   background-size: contain;
      //   text-align: center;
      //   line-height: 67px;
      //   font-family: Source Han Sans CN;
      //   font-weight: bold;
      //   color: #ffffff;
      //   font-size: 28px;
      // }
      .cell {
        // margin-left: 40px;
        margin-top: 40px;
        .biaoti {
          margin-bottom: 19px;
          display: flex;
          .xuhao {
            width: 127px;
            height: 38px;
          //  background: url("../../assets/images/dongguo/矩形 56@2x.png");
          background-color: #F7901E;
            // background: #f8921e;
            border-radius: 0px 21px 0 0;
            text-align: center;
            line-height: 38px;
            color: #ffffff;
            font-size: 26px;
            font-family: Source Han Sans CN;
            font-weight: bold;
          }
          .title {
            margin-left: 20px;
            height: 23px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #333333;
            line-height: 26px;
          }
        }
        .content {
          font-size: 24px;
          // margin-left: 40px;
          // margin-right: 55px;
          font-family: Source Han Sans CN;
          color: #666666;
          line-height: 35px;
        }
      }
      .twoCell {
        margin-top: 29px;
      }
      .threeCell {
        margin-top: 26px;
      }
    }
    .biye {
      width: 100%;
      height: 405px;
      background: #ffffff;
      border: 1px solid #dcdcdc;
      margin-top: 40px;
      .top {
        width: 100%;
        height: 67px;
        background: url("../../assets/images/dongguo/biye.png") no-repeat;
        background-size: contain;
        text-align: center;
        line-height: 67px;
        font-size: 28px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ffffff;
      }
      .cell {
        margin: 34px 60px 0 40px;
        display: flex;
        .icon {
          width: 35px;
          height: 30px;
          padding-top: 2px;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        span {
          height: 62px;
          font-size: 26px;
          font-family: Source Han Sans CN;
          color: #666666;
          line-height: 35px;
        }
      }
      .twoCell {
        margin-top: 38px;
        margin-left: 37px;
        .icon {
          width: 30px;
          height: 26px;
        }
        span {
          height: 27px;
          line-height: 40px;
        }
      }
      .threeCell {
        margin-top: 39px;
        .icon {
          width: 26px;
          height: 26px;
        }
        span {
          height: 27px;
          line-height: 40px;
        }
      }
      .fourCell {
        margin-left: 42px;
        margin-top: 42px;
        .icon {
          width: 22px;
          height: 28px;
        }
        span {
          height: 27px;
          line-height: 40px;
        }
      }
    }
    .button {
      display: block;
      text-decoration: none;
      margin: 40px auto 0;
      text-align: center;
      line-height: 42px;
      font-size: 24px;
      font-family: Source Han Sans CN;
      color: #ffffff;
      width: 193px;
      height: 42px;
      background: #f7901e;
    }
    .yuanxi {
      width: 100%;
      margin: 60px auto 0;
    }
    .introduce {
      width: 100%;
      height: 292px;
      margin-top: 40px;
      padding-top: 40px;
      background: #fff7ee;
      .oneline {
        display: flex;
        margin: 0 80px 0 30px;
        .left {
          padding-top: 3px;
          .biaozhi {
            margin-right: 20px;
            width: 3px;
            height: 17px;
            background: #f7901e;
          }
        }
        .right {
          font-size: 24px;
          font-family: Source Han Sans CN;
          color: #333333;
          line-height: 24px;
        }
      }
      .diff {
        margin-top: 28px;
      }
      .twoline {
        .right {
          line-height: 32px;
        }
      }
    }
    .jiaoyu {
      padding: 45px 45px 52px 45px;
      width: 100%;
      height: 290px;
      margin-top: 30px;
      background: url("../../assets/images/dongguo/图层 12@2x.png") no-repeat;
      background-size: contain;
      span {
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        line-height: 36px;
      }
      p{
        font-size: 24px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
        line-height: 36px;
        padding-top: 25px;
      }
    }
    .zhenrong {
      margin-top: 60px;
    }
    .person {
      display: flex;
      margin-top: 40px;
      border: 1px solid #ccc;
      li {
        width: 210px;
        height: 252px;
        margin-right: 20px;
        position: relative;
        img {
          width: 100%;
        }
        .shenfen {
          height: 43px;
          position: absolute;
          bottom: 0;
          background-color: rgba(0,0,0,0.4);
          font-size: 20px;
          font-family: Source Han Sans CN;
          color: #ffffff;
          text-align: center;
          line-height: 43px;
        }
      }
      :nth-child(3) {
        margin-right: 0;
      }
    }
    .baoming {
      margin-top: 60px;
      height: 39px;
      font-size: 40px;
      text-align: center;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #f7901e;
      line-height: 39px;
    }
    //表单
    .biaodanbox {
      width: 100%;
      margin: 0 auto;
      padding: 0 35px;
      /deep/.el-form {
        width: 600px;
        margin: 0 auto;
        position: relative;
        margin-top: 40px;
        .el-form-item {
          margin-bottom: 20px;
          p {
            display: flex;
            position: absolute;
            z-index: 1;
            top: 3px;
            left: 27px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #333333;
            .icon {
              color: #e83323;
            }
          }
          .el-select,
          .el-input {
            width: 100%;
          }
          .el-select-dropdown__item {
            span {
              font-size: 26px;
            }
          }
          .el-input__suffix {
            right: 35px;
            .el-input__suffix-inner {
              .el-input__icon {
                font-size: 26px;
              }
            }
          }
          .el-form-item__content {
            .el-input__inner {
              width: 100%;
              height: 77px;
              padding-left: 164px;
              font-size: 20px;
              line-height: 77px;
              background: #ffffff;
              border: 2px solid #d9d9d9;
              border-radius: 4px;
              letter-spacing: 2px;
            }
          }
        }
        .project {
          margin-top: 20px;
          p {
            left: 41px;
          }
        }
        .margbottom0 {
          margin-bottom: 0px;
        }
      }
      .button {
        width: 600px;
        height: 77px;
        background: #f7901e;
        border-radius: 5px;
        text-align: center;
        line-height: 77px;
        margin: 0 auto;
        cursor: pointer;
        font-size: 28px;
        box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.13);
        font-family: Source Han Sans CN;
        color: #ffffff;
        margin-top: 40px;
        margin-bottom: 61px;
      }
    }
  }
}
</style>
